import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from '@services/datasources/url.service';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { IndustryDto } from 'app/@types/dto/industry-dto.model';

/**
 * Service holding the list of industries
 */
@Injectable({
    providedIn: 'root',
})
export class IndustryService {
    private industries$?: Observable<IndustryDto[]>;

    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    public get(): Observable<IndustryDto[]> {
        if (!this.industries$) {
            this.industries$ = this.http.get<IndustryDto[]>(this.urlService.getIndustriesUrl()).pipe(
                shareReplay(1), // Cache le résultat et le partage entre tous les abonnés
            );
        }
        return this.industries$;
    }
}
